import React from 'react';
import { 
  HelpCircle, 
  TrendingUp, 
  Clock, 
  Activity, 
  Layers, 
  AlertTriangle, 
  FileText, 
  Briefcase
} from 'lucide-react';

/**
 * Компонент боковой панели с полезными советами по анализу ликвидности
 */
const TipsSidebar = () => {
  const tips = [
    {
      icon: TrendingUp,
      title: 'Нормативы ликвидности',
      description: 'Для большинства отраслей в России рекомендуемый коэффициент текущей ликвидности: от 1.5 до 2.5, быстрой ликвидности: от 0.7 до 1, абсолютной ликвидности: от 0.2.'
    },
    {
      icon: Clock,
      title: 'Периодичность анализа',
      description: 'Проводите анализ ликвидности не реже одного раза в квартал, а при нестабильной экономической ситуации — ежемесячно.'
    },
    {
      icon: Activity,
      title: 'Динамика важнее статики',
      description: 'Отслеживайте изменения показателей в динамике. Негативный тренд может указывать на проблемы, даже если текущие значения в пределах нормы.'
    },
    {
      icon: Layers,
      title: 'Баланс активов',
      description: 'Оптимизируйте структуру оборотных активов: избыток денежных средств может говорить о неэффективном управлении, а их недостаток — о рисках платежеспособности.'
    },
    {
      icon: AlertTriangle,
      title: 'Сезонность бизнеса',
      description: 'Учитывайте сезонные колебания. Для бизнеса с выраженной сезонностью нормативы могут существенно отличаться в разные периоды года.'
    },
    {
      icon: FileText,
      title: 'Особенности РСБУ',
      description: 'При использовании российских стандартов бухгалтерского учета (РСБУ) коэффициенты ликвидности могут отличаться от расчетов по МСФО из-за разницы в методологии.'
    },
    {
      icon: Briefcase,
      title: 'Отраслевая специфика',
      description: 'Сравнивайте показатели ликвидности с нормативами вашей отрасли, а не с общими рекомендациями. В торговле и услугах могут быть более низкие нормативы, чем в производстве.'
    }
  ];

  return (
    <div className="bg-white dark:bg-gray-800 rounded-xl border border-gray-200 dark:border-gray-700 p-5 shadow-sm">
      <h3 className="text-lg font-medium text-gray-900 dark:text-white mb-4 flex items-center">
        <HelpCircle className="w-5 h-5 mr-2 text-indigo-500" />
        Советы по анализу ликвидности
      </h3>

      <div className="space-y-3">
        {tips.map((tip, index) => (
          <div 
            key={index} 
            className="flex items-start space-x-3 p-3 bg-gray-50 dark:bg-gray-700/30 rounded-lg border border-gray-200 dark:border-gray-700 hover:bg-gray-100 dark:hover:bg-gray-700 transition-colors"
          >
            <tip.icon className="w-5 h-5 text-indigo-500 mt-1 flex-shrink-0" />
            <div>
              <h4 className="text-sm font-medium text-gray-900 dark:text-white mb-1">
                {tip.title}
              </h4>
              <p className="text-xs text-gray-600 dark:text-gray-400">
                {tip.description}
              </p>
            </div>
          </div>
        ))}
      </div>

      <div className="mt-6 p-4 bg-blue-50 dark:bg-blue-900/20 border border-blue-100 dark:border-blue-800 rounded-lg">
        <div className="flex items-start space-x-3">
          <HelpCircle className="w-5 h-5 text-blue-500 mt-1 flex-shrink-0" />
          <div>
            <h4 className="text-sm font-semibold text-blue-700 dark:text-blue-300 mb-2">
              Нужна консультация?
            </h4>
            <p className="text-xs text-blue-600 dark:text-blue-400 mb-3">
              Для детального анализа финансового состояния и получения индивидуальных рекомендаций рекомендуем обратиться к финансовому аналитику.
            </p>
            <button className="w-full py-1.5 text-xs bg-blue-500 text-white rounded hover:bg-blue-600 transition-colors">
              Найти консультанта
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TipsSidebar;